/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { ReleaseDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Create
 */
export const postRelease = (releaseDto: ReleaseDto, signal?: AbortSignal) => {
  return customInstance<ReleaseDto>({
    url: `/release`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: releaseDto,
    signal,
  });
};

export const getPostReleaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRelease>>,
    TError,
    { data: ReleaseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRelease>>,
  TError,
  { data: ReleaseDto },
  TContext
> => {
  const mutationKey = ["postRelease"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRelease>>,
    { data: ReleaseDto }
  > = (props) => {
    const { data } = props ?? {};

    return postRelease(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostReleaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRelease>>
>;
export type PostReleaseMutationBody = ReleaseDto;
export type PostReleaseMutationError = void;

/**
 * @summary Create
 */
export const usePostRelease = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRelease>>,
      TError,
      { data: ReleaseDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRelease>>,
  TError,
  { data: ReleaseDto },
  TContext
> => {
  const mutationOptions = getPostReleaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putReleaseId = (id: number, releaseDto: ReleaseDto) => {
  return customInstance<ReleaseDto>({
    url: `/release/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: releaseDto,
  });
};

export const getPutReleaseIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putReleaseId>>,
    TError,
    { id: number; data: ReleaseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putReleaseId>>,
  TError,
  { id: number; data: ReleaseDto },
  TContext
> => {
  const mutationKey = ["putReleaseId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putReleaseId>>,
    { id: number; data: ReleaseDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putReleaseId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutReleaseIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putReleaseId>>
>;
export type PutReleaseIdMutationBody = ReleaseDto;
export type PutReleaseIdMutationError = void;

/**
 * @summary Update
 */
export const usePutReleaseId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putReleaseId>>,
      TError,
      { id: number; data: ReleaseDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putReleaseId>>,
  TError,
  { id: number; data: ReleaseDto },
  TContext
> => {
  const mutationOptions = getPutReleaseIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All For Project
 */
export const getReleaseId = (id: number, signal?: AbortSignal) => {
  return customInstance<ReleaseDto[]>({
    url: `/release/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetReleaseIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/release/${id}`] as const;
};

export const getGetReleaseIdQueryKey = (id?: number) => {
  return [`/release/${id}`] as const;
};

export const getGetReleaseIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getReleaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getReleaseId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReleaseIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleaseId>>> = ({
    signal,
  }) => getReleaseId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getReleaseId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReleaseIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleaseId>>
>;
export type GetReleaseIdInfiniteQueryError = void;

export function useGetReleaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReleaseId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getReleaseId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleaseId>>,
          TError,
          Awaited<ReturnType<typeof getReleaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReleaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReleaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getReleaseId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleaseId>>,
          TError,
          Awaited<ReturnType<typeof getReleaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReleaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReleaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getReleaseId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All For Project
 */

export function useGetReleaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getReleaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getReleaseId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReleaseIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetReleaseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReleaseId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReleaseIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleaseId>>> = ({
    signal,
  }) => getReleaseId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleaseId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReleaseIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReleaseId>>
>;
export type GetReleaseIdQueryError = void;

export function useGetReleaseId<
  TData = Awaited<ReturnType<typeof getReleaseId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReleaseId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleaseId>>,
          TError,
          Awaited<ReturnType<typeof getReleaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReleaseId<
  TData = Awaited<ReturnType<typeof getReleaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReleaseId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleaseId>>,
          TError,
          Awaited<ReturnType<typeof getReleaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReleaseId<
  TData = Awaited<ReturnType<typeof getReleaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReleaseId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All For Project
 */

export function useGetReleaseId<
  TData = Awaited<ReturnType<typeof getReleaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReleaseId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReleaseIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteReleaseId = (id: number) => {
  return customInstance<boolean>({ url: `/release/${id}`, method: "DELETE" });
};

export const getDeleteReleaseIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReleaseId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReleaseId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteReleaseId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReleaseId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteReleaseId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReleaseIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReleaseId>>
>;

export type DeleteReleaseIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteReleaseId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReleaseId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReleaseId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteReleaseIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete All By Project Id
 */
export const deleteReleaseProjectIdByProject = (projectId: number) => {
  return customInstance<boolean>({
    url: `/release/${projectId}/by-project`,
    method: "DELETE",
  });
};

export const getDeleteReleaseProjectIdByProjectMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReleaseProjectIdByProject>>,
    TError,
    { projectId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReleaseProjectIdByProject>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationKey = ["deleteReleaseProjectIdByProject"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReleaseProjectIdByProject>>,
    { projectId: number }
  > = (props) => {
    const { projectId } = props ?? {};

    return deleteReleaseProjectIdByProject(projectId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReleaseProjectIdByProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReleaseProjectIdByProject>>
>;

export type DeleteReleaseProjectIdByProjectMutationError = void;

/**
 * @summary Delete All By Project Id
 */
export const useDeleteReleaseProjectIdByProject = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReleaseProjectIdByProject>>,
      TError,
      { projectId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReleaseProjectIdByProject>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteReleaseProjectIdByProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
